import React from "react";
import { graphql } from "gatsby";
import { BlogPost } from "../components/blog";
import { PageStructure } from "../components/pageStructure";
import Header from "../components/header";
import { calculate } from "../components/skidata";

export default function BlogPostPage({ data, location }) {
  const {
    markdownRemark: { frontmatter, html },
    allSkidataCsv: { nodes: skidata },
  } = data;

  const dataByDate = calculate(skidata);

  return (
    <PageStructure showSponsors={true}>
      <BlogPost
        title={frontmatter.title}
        date={new Date(frontmatter.date)}
        href={location.pathname}
        body={html}
        img={frontmatter.img}
        data={dataByDate.get(frontmatter.date)}
      />
    </PageStructure>
  );
}

export const Head = ({
  pageContext: { alternates, locale },
  data: {
    markdownRemark: {
      excerpt,
      frontmatter: { title, img },
    },
  },
  location,
}) => {
  return (
    <Header
      title={title}
      description={excerpt}
      alternates={alternates}
      location={location}
      img={img?.path}
      lang={locale}
    />
  );
};

export const query = graphql`
  query ($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      excerpt(pruneLength: 160)
      frontmatter {
        date
        title
        img {
          path
          alt
        }
      }
    }
    allSkidataCsv(sort: { fields: date, order: ASC }) {
      nodes {
        date
        hours
        lat
        lon
        temperature
        wind
        windDir
        altitude
      }
    }
  }
`;
